module.exports = __webpack_public_path__ + "img/chain-cat-boutique.52438506.svg";